/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { Icon, CompareValidation, ValidationMessage, HtmlParser } from 'sarsaparilla';
import get from 'lodash/get';
import { getClassName } from '../../utils/validationUtils';

const propTypes = {
    permitName: PropTypes.string,
    issuance: PropTypes.shape({
        id: PropTypes.string,
    }),
    checked: PropTypes.bool,
    toggleCheckbox: PropTypes.func,
    needToKnow: PropTypes.string,
    formValidationChange: PropTypes.func,
    validation: PropTypes.shape({}),
    displayValidationError: PropTypes.bool,
};

const defaultProps = {
    needToKnow: '',
    issuance: {},
};

export default class NeedToKnow extends React.Component {
    onFormValidate(isInValid, error, path) {
        if (isInValid) {
            this.props.formValidationChange(`${this.props.issuance.id}_${path}`, error);
        } else {
            this.props.formValidationChange(`${this.props.issuance.id}_${path}`, null);
        }
    }

    render() {
        const {
            issuance: { id },
            validation,
            displayValidationError,
            checked,
            permitName,
            needToKnow,
            toggleCheckbox,
        } = this.props;

        const needToKnowFailValidation = getClassName(
            get(validation, `${id}_need_to_know`),
            displayValidationError
        );

        return (
            <div
                className={`need-to-know ${
                    needToKnowFailValidation ? 'permit-validation-highlight' : ''
                }`}
            >
                <h2 className={'h5'}>Need to Know</h2>
                <div className="rec-notification-warning">
                    <span className="rec-notification-icon">
                        <Icon iconName="warning" />
                    </span>
                    <div className="rec-notification-body">
                        <div className="rec-notification-title-single-row">
                            Important Information:
                        </div>
                        <p>
                            Below you will find important information that regards your
                            stay with us. Please carefully read the information and click
                            the check box below to agree to our Rules and Regulations for{' '}
                            {permitName}.
                        </p>
                    </div>
                </div>
                <div className="information">
                    <div className="rec-information-head">Facility Information</div>
                    <div>
                        <HtmlParser html={needToKnow} />
                    </div>
                </div>
                <div className="rec-form-item-wrap">
                    <div className="rec-form-check-wrap">
                        <label
                            htmlFor="need-to-know-checkbox"
                            className="rec-label-checkbox"
                        >
                            <input
                                id="need-to-know-checkbox"
                                className="rec-input-hide"
                                type="checkbox"
                                checked={checked}
                                onChange={toggleCheckbox}
                            />
                            <CompareValidation
                                controlLabel="Need-to-Know"
                                value={checked}
                                displayInSummary
                                compareTo
                                onValidated={(isInValid, error) =>
                                    this.onFormValidate(isInValid, error, 'need_to_know')
                                }
                            >
                                <ValidationMessage
                                    controlName="Need-to-Know"
                                    message=" must be checked."
                                />
                            </CompareValidation>
                            <span className="rec-input-checkbox" />
                            <strong>
                                <mark title="required">*</mark> Yes, I have read and agree
                                to the Need to Know information.
                            </strong>
                        </label>
                    </div>
                </div>
            </div>
        );
    }
}

NeedToKnow.propTypes = propTypes;
NeedToKnow.defaultProps = defaultProps;
